import { throttle } from 'lodash';
import React from 'react';
export const useMouseActive = (timeoutMs) => {
    const [isUserInteractingWithElement, setIsUserInteractingWithElement] = React.useState(true);
    const mouseMoveTimer = React.useRef(undefined);
    const handleMouseMove = React.useMemo(() => throttle(() => {
        const cleanup = () => {
            if (mouseMoveTimer.current) {
                window.clearTimeout(mouseMoveTimer.current);
            }
        };
        setIsUserInteractingWithElement(true);
        cleanup();
        mouseMoveTimer.current = window.setTimeout(() => {
            setIsUserInteractingWithElement(false);
        }, timeoutMs);
        return cleanup;
    }), [timeoutMs]);
    React.useEffect(() => {
        window.addEventListener('mousemove', handleMouseMove);
        return () => window.removeEventListener('mousemove', handleMouseMove);
    });
    const handleFocus = React.useCallback(() => {
        // If the user is interacting with the element with the keyboard, we don't want to hide the controls.
        setIsUserInteractingWithElement(true);
    }, []);
    const handleBlur = React.useCallback(() => {
        setIsUserInteractingWithElement(false);
    }, []);
    return { isUserInteractingWithElement, handleFocus, handleBlur };
};
//# sourceMappingURL=use_mouse_active.preenvesnextjs.map
